export const Config = {
  defaultLanguage: 'fr',
  debug: true,
  projectName: 'Matelex',
  equipmentTareMonths: 12
};
